import('Common/paginator')

const $sort = $('#filter-sort'),
    $fakeSortButtons = $('.js-fake-sort-buttons'),
    $fakeSort = $('select#fake-sort'),
    $view = $('#filter-view'),
    $fakeView = $('.js-fake-view'),
    $bought = $('#filter-was-bought'),
    $fakeBought = $('.js-fake-bought');

let $rangeSlider;

Listing.customCallbacks.beforeFetch = () => {
    rEvent.dispatch('Listing.customBeforeFetch');
}

rEvent.on("Listing.fetchedData", function(data) {
    var $titleElemHolder = $('.js-catalog-title'),
        $titleElem = $titleElemHolder.find('h1'),
        baseName = $titleElemHolder.attr('data-name'),
        name = baseName;

    if ($titleElemHolder.length === 0) {
        return;
    }

    if (data.entity && data.entity.heading) {
        name = data.entity.heading;
    } else if (data.filtered_parameters) {
        name = baseName + " " + Object.values(data.filtered_parameters).join(" ");
    }

    if (!name) {
        return;
    }

    $titleElem.html(name);

    var title = document.title.split(" | ");

    document.title = name + " | " + title[1];
});

function updateFilterBubbles() {
    const withoutFilterBubbles = $('.js-filter-bubbles-item').length < 1;

    if (withoutFilterBubbles) {
        $('.js-filter-bubbles-reset').remove();
    }

    $('.js-filter-bubbles').toggleClass('is-empty', withoutFilterBubbles);
    $('.js-filter-submit-holder').toggleClass('without-bubbles', withoutFilterBubbles);
}

function renderFilterBubbles() {
    updateFilterBubbles();

    rEvent.on('FilterBubbles.afterRefresh', function () {
        updateFilterBubbles();
    });

    rEvent.on('FilterBubbles.returnedRefresh', function () {
        updateFilterBubbles();
    });

    $('body').on('change', '.c-aside-filter [type="checkbox"]', function () {
        updateFilterBubbles();
    });

    // filter bubbles reset hide
    $('body').on('click', '.js-filter-bubbles-item', function () {
        requestAnimationFrame(() => {
            updateFilterBubbles();
        });
    });

    $('body').on('click', '.js-filter-bubbles-reset', function () {
        $('.c-aside-filter').find('[type="reset"]').click();
        updateFilterBubbles();
    });
}

const renderMultiselect = () => {
    $('#filter select').not('.is-loaded').each(function () {
        const $select = $(this);
        let options = {
            templates: {
                button: '<button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown"><span class="multiselect-selected-text"></span><i class="ico ico-triangle-down is-on-right"></i></button>',
            },
            buttonClass: 'c-btn has-icon',
            enableHTML: true
        };

        if ($select.closest('#filter').length) {
            const moreText = $select.data('more-text')
            const lessText = $select.data('less-text')

            options.templates.ul = `
                <r-more-items r-more-items-self-target class="multiselect-container dropdown-menu" data-more-text="${moreText}" data-less-text="${lessText}">
                    <button type="button" class="c-link is-underlined is-uppercase is-more has-icon" r-more-items-trigger>
                        <span r-more-items-trigger-text>${moreText}</span>
                        <i class="ico ico-caret-down-thick is-on-right"></i>
                    </button>
                </r-more-items>
            `;
            options.templates.filter = `
                <div class="multiselect-item multiselect-filter">
                    <div class="c-form__item c-form__item--text">
                        <input class="c-form__input multiselect-search" type="text">
                        <i class="ico ico-search"></i>
                    </div>
                </div>
            `;
            options.filterPlaceholder = $select.data('filter-text');
            options.enableCaseInsensitiveFiltering = true;
            options.onFiltering = (input) => {
                const $input = $(input);
                const $dropdownMenu = $input.closest('.dropdown-menu')

                if ($input.val()) {
                    $dropdownMenu.addClass('is-filtering');
                }
                if (!$input.val()) {
                    $dropdownMenu.removeClass('is-filtering');

                    $dropdownMenu.find('li').each(function () {
                        $(this).css('display', '');
                    });
                }
            };
        }

        $select.multiselect(options);
        $select.addClass('is-loaded');
    });

    requestAnimationFrame(() => {
        addMultiselectCounts()
        addFilterAndMore()
    })
}

const addMultiselectCounts = () => {
    $('#filter').find('select[type="multiselect"]').each(function () {
        const $select = $(this),
            $options = $select.find('option'),
            $dropdownMenu = $select.next().find('.dropdown-menu'),
            type = $select.data('type');

        $options.each(function () {
            const $option = $(this),
                count = $option.data('count'),
                value = $option.val(),
                $fakeInput = $dropdownMenu.find('input[value="' + value + '"]'),
                $fakeInputLabel = $fakeInput.parent();

            if (count && !$fakeInputLabel.find('.count').length) {
                $fakeInputLabel.append(count);
                $fakeInput.parents('a')
                    .attr('data-element', 'filterItem')
                    .attr('data-type', type)
                    .attr('data-field-value', value)
                    .attr('data-count', count.replace(/<[^>]*>?/gm, '').replace(/[()]/g, ''));
            }
        });
    });
}

const addFilterAndMore = () => {
    $('#filter').find('select[type="multiselect"]').each(function () {
        const $dropdownMenu = $(this).next().find('.dropdown-menu');
        const $options = $dropdownMenu.find('li');

        if ($options.length > 6) {
            $dropdownMenu.addClass('hide-items');
            $options.each(function (key, item) {
                if (key > 3) {
                    $(this).addClass('is-hidden');
                }
            });
        }
    });
}

function updateRangeCallback(selectors, values, sliderInstance) {
    const $from = $(selectors.from),
        $to = $(selectors.to),
        fromVal = $from.val(),
        toVal = $to.val(),
        minValue = sliderInstance.options.range.min[0],
        maxValue = sliderInstance.options.range.max[0];

    if (minValue == values[0] && maxValue == values[1]) {
        // $from.val('').removeAttr('value');
        // $to.val('').removeAttr('value');

        // Filter.submit();

        // return true;
    }

    $from.val(Number(values[0]));
    $to.val(Number(values[1]));

    /*if (!fromVal && !toVal) {
        $to.trigger('change');
    }
    else if (fromVal === values[0]) {
        $to.trigger('change');
    }
    else if (toVal === values[1]) {
        $from.trigger('change');
    }*/
    Filter.submit();
}

async function createPriceRange() {
    const { default: noUiSlider } = await import(
        /* webpackChunkName: "nouislider" */
        'nouislider'
    );

    const { default: wNumb } = await import(
        /* webpackChunkName: "wnumb" */
        'wnumb'
    )

    const $elem = $('.js-range-price');
    const $slider = $elem.find('.range-slider__slider');
    const maxValue = Number($elem.attr('data-max'));
    const minValue = Number($elem.attr('data-min'));
    const fromValue = Number($elem.attr('data-from'));
    const toValue = Number($elem.attr('data-to'));
    const currencySymbol = Eshop.options.currency.symbol_right;

    if (!$slider.length) {
        return false;
    }

    $rangeSlider = noUiSlider.create($slider[0], {
        start: [fromValue, toValue],
        range: {
            'min': [minValue],
            'max': [maxValue]
        },
        margin: 1,
        connect: true,
        tooltips: [
            wNumb({
                decimals: 0,
                suffix: ` ${currencySymbol}`
            }),
            wNumb({
                decimals: 0,
                suffix: ` ${currencySymbol}`
            })
        ],
        step: 1
    });

    $rangeSlider.on('change', function (values, handle) {
        updateRangeCallback({
            from: '[name="filter[price][from]"]',
            to: '[name="filter[price][to]"]'
        }, values, this);

        $('.js-filter-price-range:checked').prop('checked', false);
    });

    $('#filter-price-from, #filter-price-to').on('keydown', function (event) {
        if (event.which == 13 || event.keyCode == 13) {
            event.preventDefault();

            $(this).blur();
            $(this).trigger('change');
        }
    });

    $('#filter-price-from').on('change', function (event) {
        event.preventDefault();

        const min = Number($(this).attr('min')),
            inputToValue = Number($('#filter-price-to').val());

        let value = Number($(this).val()),
            setInput = false;

        if (value < min) {
            value = min;
            setInput = true;
        }
        else if (value > inputToValue) {
            value = inputToValue;
            setInput = true;
        }

        if (setInput) {
            $(this).val(value);
        }

        $rangeSlider.set([value, null]);
    });

    $('#filter-price-to').on('change', function (event) {
        event.preventDefault();

        const max = Number($(this).attr('max')),
            inputFromValue = Number($('#filter-price-from').val());

        let value = Number($(this).val()),
            setInput = false;

        if (value > max) {
            value = max;
            setInput = true;
        }
        else if (value < inputFromValue) {
            value = inputFromValue;
            setInput = true;
        }

        if (setInput) {
            $(this).val(value);
        }

        $rangeSlider.set([null, value]);
    });
}

const changeFakeSortButton = (value) => {
    $fakeSortButtons.find('.c-btn').removeClass('is-active');
    $fakeSortButtons.find(`.c-btn[data-value="${value}"]`).addClass('is-active');
}

rEvent.on('Listing.customBeforeFetch', function () {
    if ($('.listing__holder').length) {
        $('.listing__holder').addClass('is-loading');
    }
    if ($('.c-msg.is-empty.listing').length) {
        $('.c-msg.is-empty.listing').addClass('is-loading');
    }
});

rEvent.on('Listing.fetchedData', function (data) {
    const $listingCount = $('.js-listing-count');

    if ($listingCount.length) {
        $listingCount.each(function () {
            const $countElem = $(this);
            let countHtml = data.count;

            if ($countElem.hasAttr('data-plural')) {
                const listingPlural = $countElem.data('plural');

                countHtml = data.count + ' ' + Format.plural(listingPlural[0], listingPlural[1], listingPlural[2], data.count);
            }

            if ($countElem.hasAttr('data-template')) {
                countHtml = $countElem.data('template').replace(':value:', countHtml);
            }

            $countElem.html(countHtml)
        });
    }
});

Filter.submit = function () {
    rEvent.dispatch("Filter.beforeSubmit");

    for (const sliderEl of this.element.querySelectorAll('.js-filter-slider-holder')) {
        const inputs = sliderEl.querySelectorAll('input')
        let isBoundary = true

        boundaryCheck:
        for (const input of inputs) {
            for (const attribute of ['min', 'max']) {
                if (input.hasAttribute(attribute) && parseFloat(input.getAttribute(attribute)) != parseFloat(input.value)) {
                    isBoundary = false;

                    break boundaryCheck;
                }
            }
        }

        if (isBoundary) {
            for (const input of inputs) {
                input.value = ''
            }
        }
    }

    Listing.sendData(this.element, (response) => {
        this.submitCallback(response)
    });

    return false;
}

FilterBubbles.create = function (filterSelector, options) {
    this.template = options.template;
    this.clearFilterTemplate = options.clearFilterTemplate;

    this.initialize();

    rEvent.dispatch('FilterBubbles.created');

    return this;
}

FilterBubbles.add = function (data) {
    if (!data.content) {
        return;
    }

    if ($(this.container).find('.js-filter-bubbles-reset').length == 0) {
        $(this.container).prepend(_.template(this.clearFilterTemplate)({
            _class: ''
        }));
    }

    $(this.container).append(_.template(this.template)(data));
    $('[data-element="filterBubbles"]').attr('data-count', $(this.holder).size());

    rEvent.dispatch('FilterBubbles.added');
}

FilterBubbles.get = function (key, value) {
    return Filter.filterInputs.filter(function () {
        if (this.name == 'filter[rating_avg]' && (['0_100', ''].includes(this.value))) {
            return false
        }

        switch (this.tagName.toLowerCase()) {
            case "select":
                return this.name == key;

            case "input":
                return this.name == key && this.value == value;
        }
    });
}

$(function () {
    renderMultiselect();
    renderFilterBubbles();

    if ($('.filter-price').length > 0) {
        createPriceRange();
    }

    // fake sort
    const sortValue = $sort.val();

    if (sortValue) {
        $fakeSort.val(sortValue);
        changeFakeSortButton(sortValue);
    }

    $fakeSort.on('change', function () {
        const value = $(this).val();

        $sort.val(value).trigger('change');
    });

    $fakeSortButtons.on('click', '.c-btn', function () {
        const value = $(this).data('value');

        changeFakeSortButton(value);
        $sort.val(value).trigger('change');
    });

    // fake bought
    $fakeBought.on('change', function () {
        const isChecked = $(this).is(':checked');

        $bought.val(isChecked ? 1 : 0);
        $bought.prop('checked', true).trigger('change');
    });

    // fake limit
    $('.l-content').on('change', '.js-paginator-limit', function () {
        const value = $('.js-paginator-limit').val();

        $('#limit').val(value);

        Filter.submit();
    });

    // fake view
    let viewValue = getCookie('listingView');

    if (viewValue) {
        $('.js-fake-view#' + viewValue).addClass('is-active');
    } else {
        $('.js-fake-view#grid').addClass('is-active');
    }

    $fakeView.on("click", function () {
        viewValue = $(this).data('value');

        $view.val(viewValue).change();
    });

    rEvent.on('Listing.changeView', function () {
        const $view = $('#filter-view'),
            value = $view.val();

        $('.js-fake-view').removeClass('is-active');
        $('.js-fake-view#' + value).addClass('is-active');

        $(".products")
            .removeClass("products--row")
            .removeClass("products--grid");
        $(".products").addClass("products--" + value);

        $(".products .js-thumb")
            .removeClass("is-row")
            .removeClass("is-grid");
        $(".products .js-thumb").addClass("is-" + value);
    });

    // filter reset
    rEvent.on("Filter.reset", function () {
        const $inputFrom = $('#filter-price-from'),
            fromValue = Number($inputFrom.attr('min')),
            $inputTo = $('#filter-price-to'),
            toValue = Number($inputTo.attr('max'));

        $inputFrom.val(fromValue);
        $inputTo.val(toValue);

        if ($rangeSlider) {
            $rangeSlider.set([fromValue, toValue]);
        }

        $('.js-filter-price-range:checked').prop('checked', false);

        $('[name="filter[rating_avg]"]').each(function() {
            // if ($(this).val() == '0_100') {
            //     $(this).prop('checked', true).change();
            // } else {
                $(this).prop('checked', false).change();
            // }
        });
    });

    $('.js-filter-price-range').on('change', function () {
        const $checkedInput = $('.js-filter-price-range:checked'),
            priceArray = $checkedInput.val().split(';'),
            actualMin = parseFloat(priceArray[0]),
            actualMax = parseFloat(priceArray[1]);

        let min = 99999,
            max = 0;

        if (actualMin < min) {
            min = actualMin;
        }

        if (actualMax > max) {
            max = actualMax;
        }

        $('#filter-price-from').val(min);
        $('#filter-price-to').val(max);

        $rangeSlider.set([min, max]);

        Filter.submit();
    });
});
